import { render, staticRenderFns } from "./ReviewLogItem.vue?vue&type=template&id=fa0236bc"
import script from "./ReviewLogItem.vue?vue&type=script&lang=ts"
export * from "./ReviewLogItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports